import React from "react";

import Products from "./Products";

const Shop = () => {
    return <Products />;
};

export default Shop;
